<ng-container *ngFor="let data of cctvCreds">
        <button mat-icon-button style="float: right;margin: 5px;border: none;" matDialogClose>
            <mat-icon>close</mat-icon>
        </button>
        <div class="cctv__popupvideo">
            <div class="cctv-frame">
                <iframe id="iframe-id" style=" width: 100%; height: 100%; " [src]="cctvURL"  title="Iframe Example"></iframe>
            </div>
        </div> 
</ng-container >
<!--========= loader =======-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>